/* eslint-disable no-prototype-builtins */
import React from 'react'
import { useQuery } from '@apollo/client'
import GET_NOTIFICATIONS from 'Apollo/Queries/GetNotifications'
import { useAppState } from 'Context/AppContext/AppContext'
import useLocalStorage from 'Hooks/useLocalStorage'
import { analytics } from 'Modules/Analytics'
import { useLocation } from 'react-router-dom'
import { Notification } from './Notification'
import { useStyles } from './styles'
import {
  NotificationType,
  NOTIFICATION_TYPES,
  notificationData,
} from './NotificationData'

const DISMISSAL_LENGTH = 86400

const NotificationBanner = () => {
  const {
    nonprofitOrgConfig: { stripeConnectId, orgId },
    userConfig: { id: userId },
  } = useAppState()
  const [
    dismissedNotificationsString,
    setDismissedNotification,
  ] = useLocalStorage(`dismissedNotifications`)
  const classes = useStyles()

  const { pathname } = useLocation()
  const isResource = !!pathname.split('search/')[1]

  let dismissedNotifications: Record<
    string,
    Record<NOTIFICATION_TYPES, { clearedAt: number }>
  >
  if (dismissedNotificationsString) {
    dismissedNotifications = JSON.parse(dismissedNotificationsString)
  }

  const { data } = useQuery(GET_NOTIFICATIONS, {
    fetchPolicy: 'network-only',
    variables: { stripeConnectId },
    skip: !stripeConnectId,
  })

  // filter out any notifications that have been cleared by the user in the last 24 hours
  const notificationsToShow = data?.getNotifications?.filter(
    ({ type }: { type: NOTIFICATION_TYPES }) => {
      if (
        dismissedNotifications &&
        dismissedNotifications[userId] &&
        dismissedNotifications[userId].hasOwnProperty(type)
      ) {
        return (
          new Date().getTime() / 1000 -
            dismissedNotifications[userId][type]?.clearedAt >=
          DISMISSAL_LENGTH
        )
      }
      return true
    }
  )
  const handleDismissal = (notificationType: string) => {
    const clearObject = {
      [notificationType]: {
        clearedAt: new Date().getTime() / 1000,
      },
    }
    const dispatchDismissalClicked = analytics.trackActionCreator(
      notificationData[notificationType as NOTIFICATION_TYPES].events.dismissed
    )
    dispatchDismissalClicked({
      userId,
      nonprofitOrgId: orgId,
      url: window.location.href,
    })
    const newClearedNotifications = dismissedNotifications
      ? {
          ...dismissedNotifications,
          [userId]: {
            ...dismissedNotifications[userId],
            ...clearObject,
          },
        }
      : {
          [userId]: clearObject,
        }
    setDismissedNotification(JSON.stringify(newClearedNotifications))
  }

  return notificationsToShow?.length && !isResource ? (
    <>
      {notificationsToShow.map((notification: NotificationType) => (
        <Notification
          key={notification.type}
          handleDismissal={handleDismissal}
          notification={notification}
        />
      ))}
    </>
  ) : null
}

export default NotificationBanner
